import { Menu, MenuItem } from "@clockwise/design-system";
import { fg_muted } from "@clockwise/design-system/tokens";
import { DotsThree } from "phosphor-react";
import React from "react";

type Props = {
  feedbackURL: string;
  changelogUrl: string;
};

export const CalendarMoreOptions = ({ feedbackURL, changelogUrl }: Props) => {
  return (
    <Menu
      label={<DotsThree color={fg_muted} aria-label="more options" />}
      variant="inline"
      size="small"
      aria-label="more options"
    >
      <MenuItem href={changelogUrl}>Changelog</MenuItem>
      <MenuItem href={feedbackURL}>Give feedback</MenuItem>
    </Menu>
  );
};
